var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-view"},[_c('div',{staticClass:"loader-icon"},[_c('loader')],1),_c('div',{staticStyle:{"margin-left":"10px"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }